// Etiquetas en español para mostrar cambios de auditoría y resúmenes de edición

export const CONSULTA_FIELD_LABELS = {
  peso: 'Peso (kg)',
  talla: 'Talla (m)',
  temperatura: 'Temperatura (°C)',
  tension_arterial_sistolica: 'T/A Sistólica',
  tension_arterial_diastolica: 'T/A Diastólica',
  frecuencia_cardiaca: 'Frecuencia Cardiaca',
  frecuencia_respiratoria: 'Frecuencia Respiratoria',
  aseguradora: 'Aseguradora',
  medio_llegada: 'Medio de Llegada',
  fecha_ingreso: 'Fecha de Ingreso',
  fracturas: 'Fracturas Previas',
  enfermedades_previas: 'Enfermedades Previas',
  hospitalizaciones_previas: 'Hospitalizaciones Previas',
  fumas_o_tomas: 'Consumo de Sustancias',
  adicciones: 'Adicciones',
  antecedentes_familiares: 'Antecedentes Familiares',
  antecedentes_personales_no_patologicos: 'Antecedentes Personales No Patológicos',
  antecedentes_personales_patologicos: 'Antecedentes Personales Patológicos',
  antecedentes_gineco_obstetricos: 'Antecedentes Gineco-Obstétricos',
  motivo_consulta: 'Motivo de Consulta',
  interrogatorio: 'Interrogatorio',
  exploracion_fisica: 'Exploración Física',
  diagnostico_cie10: 'Diagnóstico CIE-10',
  tratamiento: 'Tratamiento',
  solicitar_laboratorio: 'Solicitar Laboratorio',
  solicitud_laboratorio: 'Solicitud de Laboratorio',
  resultados_laboratorio: 'Resultados de Laboratorio',
  pronostico: 'Pronóstico',
};

export const PACIENTE_FIELD_LABELS = {
  nombre: 'Nombre',
  genero: 'Género',
  fecha_nacimiento: 'Fecha de Nacimiento',
  ocupacion: 'Ocupación',
  domicilio: 'Domicilio',
  nombre_tutor: 'Tutor',
};

export const formatAuditValue = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  if (Array.isArray(value)) return value.length > 0 ? value.join(', ') : '—';
  if (typeof value === 'boolean') return value ? 'Sí' : 'No';
  const text = String(value);
  // Fechas ISO completas se muestran en formato local
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(text)) {
    const date = new Date(text);
    if (!Number.isNaN(date.getTime())) return date.toLocaleString('es-MX');
  }
  return text;
};
